import React from 'react';
import { Brain, Music2, Heart, Trophy, Zap, Target } from 'lucide-react';
import { motion } from 'framer-motion';

const FeatureCard = ({ icon: Icon, title, description }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    className="glass p-6 rounded-xl"
  >
    <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center mb-4">
      <Icon className="w-6 h-6" />
    </div>
    <h3 className="text-xl font-semibold mb-2">{title}</h3>
    <p className="text-gray-300">{description}</p>
  </motion.div>
);

export const Features = () => {
  const features = [
    {
      icon: Brain,
      title: "AI-Powered Coaching",
      description: "Get real-time feedback and personalized training plans adapted to your goals and progress."
    },
    {
      icon: Music2,
      title: "Adaptive Music",
      description: "Music that automatically adjusts to match your pace and keep you in the perfect rhythm."
    },
    {
      icon: Heart,
      title: "Health Insights",
      description: "Deep analysis of your vital signs and performance metrics to optimize your training."
    },
    {
      icon: Trophy,
      title: "Achievement System",
      description: "Stay motivated with dynamic challenges and rewards that evolve with your fitness level."
    },
    {
      icon: Zap,
      title: "Voice Control",
      description: "Hands-free operation with natural voice commands for a seamless running experience."
    },
    {
      icon: Target,
      title: "Goal Tracking",
      description: "Set and track your running goals with intelligent progress monitoring and adjustments."
    }
  ];

  return (
    <section className="py-20 px-4 bg-black">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">
            Transform Your Running Experience
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Discover how RunAI Coach combines cutting-edge AI with proven training methods to help you achieve your running goals.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>
      </div>
    </section>
  );
};